(function () {
  const storageKey = 'scProductGroupSelectedOptions';
  const maxStorageAge = 5 * 60 * 1000;

  function parseJsonScript(script) {
    try {
      return JSON.parse(script.textContent || '{}');
    } catch (error) {
      console.warn('[sc-product-group-options] Failed to parse JSON data.', error);
      return null;
    }
  }

  function logWarnings() {
    document.querySelectorAll('[data-sc-product-group-options-json]').forEach((script) => {
      if (script.dataset.scWarningsLogged === 'true') return;

      const data = parseJsonScript(script);
      script.dataset.scWarningsLogged = 'true';

      if (!data || !Array.isArray(data.warnings)) return;

      data.warnings.forEach((warning) => {
        console.warn('[sc-product-group-options]', warning.message, warning);
      });
    });
  }

  function normalizeOptionText(value) {
    return String(value || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function getProductInfoScope(element) {
    return element.closest('product-info') || document;
  }

  let collectGloboSelectedOptions = () => [];
  let initGloboColorSwatchIntegration = () => {};

  // SC Globo Color Swatch integration start
  const globoObservedScopes = new WeakSet();

  function getProductGroupData(scope) {
    const script = scope.querySelector('[data-sc-product-group-options-json]');
    return script ? parseJsonScript(script) : null;
  }

  function getGloboRoot(scope) {
    return scope.querySelector('.globo-swatch-product-detail');
  }

  function getGloboSwatchList(globoRoot) {
    return globoRoot?.querySelector('.globo-swatch-list');
  }

  let globoConfigWarningLogged = false;

  function getGloboProductPageConfig() {
    const rootConfig =
      window.GloboSwatchConfig || window.configGloboSwatch || window.globoswatch || window.globoSwatchConfig || null;
    const productPageConfig = rootConfig?.product_page || rootConfig?.productPage || rootConfig;

    if (
      productPageConfig &&
      (productPageConfig.customize_pill_button ||
        productPageConfig.customize_pill_button_product ||
        productPageConfig.customize_button_with_price ||
        productPageConfig.customize_button_with_price_product)
    ) {
      return productPageConfig;
    }

    if (!globoConfigWarningLogged) {
      console.warn('[sc-product-group-options] Globo product page config was not found.');
      globoConfigWarningLogged = true;
    }

    return null;
  }

  function getGloboStyleSettings() {
    const config = getGloboProductPageConfig() || {};

    return {
      button: config.style_product_page_button || config.customize_button || {},
      pill: config.customize_pill_button_product || config.customize_pill_button || {},
      price: config.customize_button_with_price_product || config.customize_button_with_price || {},
      swatch: config.style_product_page_swatch || config.customize_swatch || {},
    };
  }

  function normalizeProductGroupStyle(style) {
    const normalizedStyle = normalizeOptionText(style).toLowerCase();

    if (normalizedStyle === 'button-with-price' || normalizedStyle === 'button with price') return 'button-with-price';
    if (normalizedStyle === 'color-swatch' || normalizedStyle === 'color swatch') return 'color-swatch';
    if (normalizedStyle === 'image-swatch' || normalizedStyle === 'image swatch') return 'image-swatch';

    return 'button';
  }

  function globoColor(colorSet, state, fallback) {
    return colorSet?.[state] || fallback || '';
  }

  function globoFontWeight(value, fallback = '400') {
    if (value === 'bold') return '700';
    if (value === 'none' || value == null || value === '') return fallback;
    return String(value);
  }

  function globoTextTransform(value) {
    if (value === 'uppercase' || value === 'lowercase') return value;
    return 'none';
  }

  function globoButtonPadding(buttonSize, buttonCorner) {
    if (buttonCorner === 'pill') {
      if (buttonSize === 'small') return '3px 18px';
      if (buttonSize === 'large') return '8px 25px';
      return '5px 20px';
    }

    if (buttonSize === 'small') return '3px 8px';
    if (buttonSize === 'large') return '8px 18px';
    return '6px 14px';
  }

  function globoButtonFontSize(buttonSize) {
    if (buttonSize === 'small') return '12px';
    if (buttonSize === 'large') return '16px';
    return '13px';
  }

  function globoButtonRadius(buttonCorner) {
    if (buttonCorner === 'pill') return '25px';
    if (buttonCorner === 'rounded') return '5px';
    return '0';
  }

  function globoButtonClassNames() {
    const button = getGloboStyleSettings().button;
    const cornerClass =
      button.button_corner === 'pill'
        ? 'globo-detail-button-style-pill'
        : button.button_corner === 'rounded'
          ? 'globo-detail-button-style-rounded'
          : '';
    const sizeClass = button.button_size ? `globo-detail-button-size-${button.button_size}` : '';
    const textClass = button.text_style ? `globo-detail-text-style-${button.text_style}` : '';
    const hoverEffect = button.hover_effects?.background;
    const hoverClass =
      hoverEffect === 'add glow'
        ? 'globo-detail-button-effects-glow'
        : hoverEffect === 'add shadow'
          ? 'globo-detail-button-effects-shadow'
          : '';

    return ['globo-style--button', cornerClass, sizeClass, textClass, hoverClass].filter(Boolean).join(' ');
  }

  function globoPillClassNames() {
    const pill = getGloboStyleSettings().pill;
    const sizeClass = `globo-detail-pill-button-size-${pill.button_size || 'medium'}`;
    const textClass = `globo-detail-pill-button-text-style-${pill.text_style || 'default'}`;
    const hoverEffect = pill.hover_effects?.background;
    const hoverClass =
      hoverEffect === 'add glow'
        ? 'globo-detail-pill-button-effects-glow'
        : hoverEffect === 'add shadow'
          ? 'globo-detail-pill-button-effects-shadow'
          : '';

    return ['globo-detail-style--pill-button', sizeClass, textClass, hoverClass].filter(Boolean).join(' ');
  }

  function getGloboRenderClassNames(renderMode) {
    if (renderMode === 'button') return globoButtonClassNames();
    if (renderMode === 'pill') return globoPillClassNames();
    if (renderMode === 'button-with-price') return 'gcw-detail-content-button-with-price';
    if (renderMode === 'color-swatch' || renderMode === 'image-swatch') return 'globo-border-color-swatch';
    return '';
  }

  function setGloboStyleVars(element, vars) {
    Object.entries(vars).forEach(([key, value]) => {
      if (value == null || value === '') return;
      element.style.setProperty(key, String(value));
    });
  }

  function applyGloboPillStyle(control) {
    const settings = getGloboStyleSettings();
    const pill = settings.pill;
    const button = settings.button;

    setGloboStyleVars(control, {
      '--sc-globo-pill-background': globoColor(pill.background_color, 'normal'),
      '--sc-globo-pill-background-hover': globoColor(pill.background_color, 'hover'),
      '--sc-globo-pill-background-selected': globoColor(pill.background_color, 'selected'),
      '--sc-globo-pill-border': globoColor(pill.border_color, 'normal', globoColor(button.border_color, 'normal')),
      '--sc-globo-pill-border-hover': globoColor(pill.border_color, 'hover'),
      '--sc-globo-pill-border-selected': globoColor(pill.border_color, 'selected'),
      '--sc-globo-pill-color': globoColor(pill.text_color, 'normal'),
      '--sc-globo-pill-color-hover': globoColor(pill.text_color, 'hover'),
      '--sc-globo-pill-color-selected': globoColor(pill.text_color, 'selected'),
      '--sc-globo-pill-border-width': `${pill.thickness_style_single || 1}px`,
      '--sc-globo-pill-padding': globoButtonPadding(pill.button_size, 'pill'),
      '--sc-globo-pill-gap': `${pill.button_spacing || button.button_spacing || 6}px`,
      '--sc-globo-pill-font-size': globoButtonFontSize(pill.button_size),
      '--sc-globo-pill-font-weight': globoFontWeight(pill.text_font_weight),
      '--sc-globo-pill-text-transform': globoTextTransform(pill.text_style),
    });
  }

  function applyGloboButtonStyle(control) {
    const settings = getGloboStyleSettings();
    const button = settings.button;

    setGloboStyleVars(control, {
      '--sc-globo-button-background': globoColor(button.background_color, 'normal'),
      '--sc-globo-button-background-hover': globoColor(button.background_color, 'hover'),
      '--sc-globo-button-background-selected': globoColor(button.background_color, 'selected'),
      '--sc-globo-button-border': globoColor(button.border_color, 'normal'),
      '--sc-globo-button-border-hover': globoColor(button.border_color, 'hover'),
      '--sc-globo-button-border-selected': globoColor(button.border_color, 'selected'),
      '--sc-globo-button-color': globoColor(button.text_color, 'normal'),
      '--sc-globo-button-color-hover': globoColor(button.text_color, 'hover'),
      '--sc-globo-button-color-selected': globoColor(button.text_color, 'selected'),
      '--sc-globo-button-padding': globoButtonPadding(button.button_size, button.button_corner),
      '--sc-globo-button-radius': globoButtonRadius(button.button_corner),
      '--sc-globo-button-gap': `${button.button_spacing || 6}px`,
      '--sc-globo-button-font-size': globoButtonFontSize(button.button_size),
      '--sc-globo-button-font-weight': globoFontWeight(button.text_font_weight),
      '--sc-globo-button-text-transform': globoTextTransform(button.text_style),
    });
  }

  function applyGloboPriceStyle(control) {
    const settings = getGloboStyleSettings();
    const button = settings.button;
    const price = settings.price;
    const priceBoxWidth = Number(price.box_width) || 90;
    const titleFontSize = Number(price.text_font_size) || 13;
    const priceFontSize = Number(price.price_font_size) || 12;

    setGloboStyleVars(control, {
      '--sc-globo-price-width': `${price.box_width || 90}px`,
      '--sc-globo-price-min-width': `${Math.max(priceBoxWidth, 112)}px`,
      '--sc-globo-price-radius': `${price.button_border_radius ?? 4}px`,
      '--sc-globo-price-border-width': `${price.button_thickness_style_single || 1}px`,
      '--sc-globo-price-gap': `${price.button_spacing || 6}px`,
      '--sc-globo-price-border': globoColor(price.border_color, 'normal'),
      '--sc-globo-price-border-hover': globoColor(price.border_color, 'hover'),
      '--sc-globo-price-border-selected': globoColor(price.border_color, 'selected'),
      '--sc-globo-price-visual-border': globoColor(button.border_color, 'normal', globoColor(price.border_color, 'normal')),
      '--sc-globo-price-visual-border-hover': globoColor(button.border_color, 'hover', globoColor(price.border_color, 'hover')),
      '--sc-globo-price-visual-border-selected': globoColor(
        button.border_color,
        'selected',
        globoColor(price.border_color, 'selected')
      ),
      '--sc-globo-price-name-color': globoColor(price.variant_name_color, 'normal'),
      '--sc-globo-price-name-color-hover': globoColor(price.variant_name_color, 'hover'),
      '--sc-globo-price-name-color-selected': globoColor(price.variant_name_color, 'selected'),
      '--sc-globo-price-name-background': globoColor(price.variant_name_background_color, 'normal'),
      '--sc-globo-price-name-background-hover': globoColor(price.variant_name_background_color, 'hover'),
      '--sc-globo-price-name-background-selected': globoColor(price.variant_name_background_color, 'selected'),
      '--sc-globo-price-name-visual-color': globoColor(button.text_color, 'normal', globoColor(price.variant_name_color, 'normal')),
      '--sc-globo-price-name-visual-color-hover': globoColor(
        button.text_color,
        'hover',
        globoColor(price.variant_name_color, 'hover')
      ),
      '--sc-globo-price-name-visual-color-selected': globoColor(
        button.text_color,
        'selected',
        globoColor(price.variant_name_color, 'selected')
      ),
      '--sc-globo-price-name-visual-background': globoColor(
        button.background_color,
        'normal',
        globoColor(price.variant_name_background_color, 'normal')
      ),
      '--sc-globo-price-name-visual-background-hover': globoColor(
        button.background_color,
        'hover',
        globoColor(price.variant_name_background_color, 'hover')
      ),
      '--sc-globo-price-name-visual-background-selected': globoColor(
        button.background_color,
        'selected',
        globoColor(price.variant_name_background_color, 'selected')
      ),
      '--sc-globo-price-value-color': globoColor(price.price_color, 'normal'),
      '--sc-globo-price-value-color-hover': globoColor(price.price_color, 'hover'),
      '--sc-globo-price-value-color-selected': globoColor(price.price_color, 'selected'),
      '--sc-globo-price-value-visual-color': globoColor(button.text_color, 'normal', globoColor(price.price_color, 'normal')),
      '--sc-globo-price-value-visual-color-hover': globoColor(
        button.text_color,
        'normal',
        globoColor(price.price_color, 'hover')
      ),
      '--sc-globo-price-value-visual-color-selected': globoColor(
        button.text_color,
        'normal',
        globoColor(price.price_color, 'selected')
      ),
      '--sc-globo-price-value-background': globoColor(price.price_background_color, 'normal'),
      '--sc-globo-price-value-background-hover': globoColor(price.price_background_color, 'hover'),
      '--sc-globo-price-value-background-selected': globoColor(price.price_background_color, 'selected'),
      '--sc-globo-price-name-font-size': `${titleFontSize}px`,
      '--sc-globo-price-value-font-size': `${priceFontSize}px`,
      '--sc-globo-price-name-font-weight': globoFontWeight(price.text_font_weight),
      '--sc-globo-price-value-font-weight': globoFontWeight(price.price_font_weight),
    });
  }

  function applyGloboSwatchStyle(control, renderMode, groupProduct) {
    const settings = getGloboStyleSettings();
    const swatch = settings.swatch;
    const swatchSize = swatch.swatch_size_customize || 35;
    const borderRadius =
      swatch.swatch_shape === 'circle' ? '50%' : swatch.swatch_border_radius != null ? `${swatch.swatch_border_radius}px` : '0';
    const borderWidth = swatch.swatch_thickness_style_single || 1;

    setGloboStyleVars(control, {
      '--sc-globo-swatch-size': `${swatchSize}px`,
      '--sc-globo-swatch-radius': borderRadius,
      '--sc-globo-swatch-border-width': `${borderWidth}px`,
      '--sc-globo-swatch-border': globoColor(swatch.border_color, 'normal', '#dddddd'),
      '--sc-globo-swatch-border-hover': globoColor(swatch.border_color, 'hover', '#1c1c1c'),
      '--sc-globo-swatch-border-selected': globoColor(swatch.border_color, 'selected', '#1c1c1c'),
      '--sc-globo-swatch-background': renderMode === 'color-swatch' ? groupProduct.color : 'transparent',
    });

    if (renderMode === 'image-swatch' && groupProduct.image_url) {
      control.style.setProperty('--sc-globo-swatch-image', `url(${groupProduct.image_url})`);
    }
  }

  function getGloboRenderModeForTargetGroup(targetGroup) {
    const valueList = targetGroup?.querySelector('ul.value');
    const firstControl = targetGroup?.querySelector('.swatch-anchor, .gcw-detail-content-button-with-price');

    if (!targetGroup || !valueList) return 'button';
    if (valueList.classList.contains('gcw-detail-button-with-price')) return 'button-with-price';
    if (
      valueList.classList.contains('gcw-variant-img-swatch-with-price') ||
      valueList.dataset.useVariantImage === 'true'
    ) {
      return 'image-swatch';
    }
    if (firstControl?.classList.contains('globo-style--button')) return 'button';
    if (firstControl?.classList.contains('globo-detail-style--pill-button')) return 'pill';
    if (firstControl?.classList.contains('globo-border-color-swatch')) {
      const backgroundImage = getComputedStyle(firstControl).backgroundImage;
      return backgroundImage && backgroundImage !== 'none' ? 'image-swatch' : 'color-swatch';
    }

    return 'button';
  }

  function getGloboGroupByOptionName(globoRoot, optionName) {
    const normalizedOptionName = normalizeOptionText(optionName);

    return Array.from(globoRoot.querySelectorAll('.swatch--gl')).find((group) => {
      const legend = group.querySelector('legend.name-option[data-name]');
      return normalizeOptionText(legend?.dataset.name) === normalizedOptionName;
    });
  }

  function getCurrentProductFromGroup(group) {
    return group.products?.find((groupProduct) => groupProduct.is_current);
  }

  function getProductIdentity(groupProduct) {
    return String(groupProduct?.id || groupProduct?.handle || groupProduct?.url || '').trim();
  }

  function getUniqueGroupProducts(group) {
    const seen = new Set();

    return (group.products || []).filter((groupProduct) => {
      const identity = getProductIdentity(groupProduct);

      if (!identity) return false;
      if (seen.has(identity)) return false;

      seen.add(identity);
      return true;
    });
  }

  function createGloboOptionItem({ group, groupProduct, isCurrent, renderMode }) {
    const item = document.createElement('li');
    item.className = `select-option available sc-product-group-options__globo-item${
      isCurrent ? ' sc-product-group-options__globo-item--current' : ''
    } sc-product-group-options__globo-item--${renderMode}`;
    item.dataset.scProductId = groupProduct.id;

    const control = document.createElement(isCurrent ? 'span' : 'a');
    const globoClassNames = getGloboRenderClassNames(renderMode);
    control.className = `swatch-anchor swatch-other ${globoClassNames} sc-product-group-options__globo-control sc-product-group-options__globo-control--${renderMode} ${
      isCurrent ? 'sc-product-group-options__globo-current' : 'sc-product-group-options__globo-link'
    }`;
    control.dataset.scProductId = groupProduct.id;
    control.dataset.scRenderMode = renderMode;

    if (isCurrent) {
      control.setAttribute('aria-current', 'true');
    } else {
      control.href = groupProduct.url;
      control.dataset.scProductGroupLink = '';
      control.dataset.scProductUrl = groupProduct.url;
    }

    control.title = groupProduct.label || groupProduct.title || '';
    control.setAttribute('aria-label', groupProduct.label || groupProduct.title || '');

    if (renderMode === 'color-swatch' || renderMode === 'image-swatch') {
      const hiddenLabel = document.createElement('span');
      hiddenLabel.className = 'visually-hidden';
      hiddenLabel.textContent = groupProduct.label || groupProduct.title || '';
      control.append(hiddenLabel);
    } else {
      const label = document.createElement('span');
      label.className =
        renderMode === 'button-with-price'
          ? 'gcw-detail-txt--variant-name sc-product-group-options__globo-price-name'
          : 'sc-product-group-options__label';
      label.textContent = groupProduct.label;
      control.append(label);
    }

    if (renderMode === 'button-with-price' && groupProduct.min_price_formatted) {
      const price = document.createElement('span');
      price.className = 'gcw-detail-txt--variant-price sc-product-group-options__globo-price-value';
      price.textContent = `ab ${groupProduct.min_price_formatted}`;
      control.append(price);
    }

    if (renderMode === 'button-with-price') {
      applyGloboPriceStyle(control);
    } else if (renderMode === 'button') {
      applyGloboButtonStyle(control);
    } else if (renderMode === 'color-swatch' || renderMode === 'image-swatch') {
      applyGloboSwatchStyle(control, renderMode, groupProduct);
    } else {
      applyGloboPillStyle(control);
    }

    item.append(control);
    return item;
  }

  function injectAppendGloboGroup({ globoRoot, group }) {
    const targetGroup = getGloboGroupByOptionName(globoRoot, group.option_name);
    const valueList = targetGroup?.querySelector('ul.value');

    if (!targetGroup || !valueList) {
      console.warn('[sc-product-group-options] Globo target option group was not found.', group);
      return;
    }

    const renderMode = getGloboRenderModeForTargetGroup(targetGroup);

    getUniqueGroupProducts(group)
      ?.filter((groupProduct) => !groupProduct.is_current)
      .forEach((groupProduct) => {
        valueList.append(
          createGloboOptionItem({
            group,
            groupProduct,
            isCurrent: false,
            renderMode,
          })
        );
      });
  }

  function injectStandaloneGloboGroup({ globoRoot, swatchList, group }) {
    const currentProduct = getCurrentProductFromGroup(group);
    const renderMode = normalizeProductGroupStyle(group.style);
    const globoGroup = document.createElement('div');
    globoGroup.className = `swatch--gl clearfix sc-product-group-options__globo-group sc-product-group-options__globo-group--${renderMode}`;
    globoGroup.dataset.scProductGroupHandle = group.system_handle || group.id || group.title;

    const legend = document.createElement('legend');
    legend.className = 'name-option';
    legend.dataset.name = group.title;
    legend.append(document.createTextNode(group.title));

    if (currentProduct?.label && renderMode !== 'color-swatch' && renderMode !== 'image-swatch') {
      const nameVariant = document.createElement('span');
      nameVariant.className = 'name-variant';

      const separator = document.createElement('span');
      separator.textContent = ': ';
      nameVariant.append(separator, document.createTextNode(currentProduct.label));
      legend.append(nameVariant);
    }

    const valueList = document.createElement('ul');
    valueList.className = `value sc-product-group-options__globo-list sc-product-group-options__globo-list--${renderMode}`;
    if (renderMode === 'button-with-price') {
      valueList.classList.add('gcw-detail-button-with-price');
    }
    if (renderMode === 'color-swatch' || renderMode === 'image-swatch') {
      valueList.classList.add('g-variant-color-detail');
    }

    getUniqueGroupProducts(group).forEach((groupProduct) => {
      valueList.append(
        createGloboOptionItem({
          group,
          groupProduct,
          isCurrent: Boolean(groupProduct.is_current),
          renderMode,
        })
      );
    });

    globoGroup.append(legend, valueList);

    if (group.position === 'top') {
      swatchList.prepend(globoGroup);
    } else {
      swatchList.append(globoGroup);
    }
  }

  function hideThemeStandaloneGroupsForGlobo(scope) {
    scope.querySelectorAll('.sc-product-group-options--standalone').forEach((group) => {
      if (group.closest('.globo-swatch-product-detail')) return;

      group.classList.add('sc-product-group-options--globo-hidden');
      group.setAttribute('aria-hidden', 'true');
    });
  }

  function injectGloboProductGroupOptions(scope = document) {
    const data = getProductGroupData(scope);
    const globoRoot = getGloboRoot(scope);
    const swatchList = getGloboSwatchList(globoRoot);

    if (!data?.groups?.length || !globoRoot || !swatchList) return false;
    hideThemeStandaloneGroupsForGlobo(scope);

    if (globoRoot.dataset.scProductGroupGloboInjected === 'true') return true;

    data.groups
      .filter((group) => group.add_in_options)
      .forEach((group) => {
        injectAppendGloboGroup({ globoRoot, group });
      });

    data.groups
      .filter((group) => !group.add_in_options && group.position === 'top')
      .reverse()
      .forEach((group) => {
        injectStandaloneGloboGroup({ globoRoot, swatchList, group });
      });

    data.groups
      .filter((group) => !group.add_in_options && group.position !== 'top')
      .forEach((group) => {
        injectStandaloneGloboGroup({ globoRoot, swatchList, group });
      });

    globoRoot.dataset.scProductGroupGloboInjected = 'true';
    return true;
  }

  collectGloboSelectedOptions = function (scope) {
    const globoRoot = getGloboRoot(scope);
    if (!globoRoot) return [];

    return Array.from(globoRoot.querySelectorAll('.swatch--gl'))
      .map((group) => {
        const legend = group.querySelector('legend.name-option[data-name]');
        const checkedInput = group.querySelector('input:checked');

        return {
          name: normalizeOptionText(legend?.dataset.name),
          value: normalizeOptionText(checkedInput?.value),
        };
      })
      .filter((option) => option.name && option.value);
  };

  initGloboColorSwatchIntegration = function () {
    document.querySelectorAll('[data-sc-product-group-options-json]').forEach((script) => {
      const scope = getProductInfoScope(script);

      if (injectGloboProductGroupOptions(scope)) return;

      if (globoObservedScopes.has(scope)) return;
      globoObservedScopes.add(scope);

      const observerTarget = scope === document ? document.documentElement : scope;
      const observer = new MutationObserver(() => {
        injectGloboProductGroupOptions(scope);
      });

      observer.observe(observerTarget, { childList: true, subtree: true });
    });
  };
  // SC Globo Color Swatch integration end

  function collectSelectedOptions(scope) {
    const globoSelectedOptions = collectGloboSelectedOptions(scope);
    if (globoSelectedOptions.length) return globoSelectedOptions;

    return Array.from(scope.querySelectorAll('.product-form__input [data-selected-swatch-value]'))
      .map((selectedValue) => ({
        name: selectedValue.getAttribute('data-selected-swatch-value'),
        value: selectedValue.textContent.trim(),
      }))
      .filter((option) => option.name && option.value);
  }

  function getCurrentProductId(scope) {
    const script = scope.querySelector('[data-sc-product-group-options-json]');
    const data = script ? parseJsonScript(script) : null;
    return data?.current_product_id || null;
  }

  function storeSelectedOptions(link) {
    const scope = getProductInfoScope(link);
    const selectedOptions = collectSelectedOptions(scope);

    if (!selectedOptions.length) return;

    try {
      const targetUrl = new URL(link.href, window.location.href);

      sessionStorage.setItem(
        storageKey,
        JSON.stringify({
          timestamp: Date.now(),
          sourceProductId: getCurrentProductId(scope),
          targetProductId: link.dataset.scProductId || null,
          targetPathname: targetUrl.pathname,
          options: selectedOptions,
        })
      );
    } catch (error) {
      console.warn('[sc-product-group-options] Failed to store selected options.', error);
    }
  }

  function readStoredOptions() {
    let payload = null;

    try {
      payload = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
    } catch (error) {
      sessionStorage.removeItem(storageKey);
      return null;
    }

    if (!payload) return null;

    const isExpired = !payload.timestamp || Date.now() - payload.timestamp > maxStorageAge;
    const isDifferentTarget = payload.targetPathname && payload.targetPathname !== window.location.pathname;

    if (isExpired || isDifferentTarget) {
      sessionStorage.removeItem(storageKey);
      return null;
    }

    sessionStorage.removeItem(storageKey);
    return Array.isArray(payload.options) ? payload.options : null;
  }

  function valuesMatch(first, second) {
    return normalizeOptionText(first) === normalizeOptionText(second);
  }

  function findOptionInput(wrapper, value) {
    return Array.from(wrapper.querySelectorAll('input[type="radio"]')).find((input) => {
      return valuesMatch(input.value, value) && !input.disabled && !input.classList.contains('disabled');
    });
  }

  function findSelectOption(select, value) {
    return Array.from(select.options).find((option) => {
      return valuesMatch(option.value, value) && !option.disabled;
    });
  }

  function applyStoredOptions() {
    const storedOptions = readStoredOptions();
    if (!storedOptions || !storedOptions.length) return;

    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;

    const changedControls = [];

    storedOptions.forEach((storedOption) => {
      const wrapper = Array.from(variantSelects.querySelectorAll('.product-form__input')).find((inputWrapper) => {
        const selectedValue = inputWrapper.querySelector('[data-selected-swatch-value]');
        return selectedValue && selectedValue.getAttribute('data-selected-swatch-value') === storedOption.name;
      });

      if (!wrapper) return;

      const select = wrapper.querySelector('select');

      if (select) {
        const option = findSelectOption(select, storedOption.value);
        if (!option || option.selected) return;

        select.value = option.value;
        changedControls.push(select);
        return;
      }

      const input = findOptionInput(wrapper, storedOption.value);
      if (!input || input.checked) return;

      input.checked = true;
      changedControls.push(input);
    });

    const lastChangedControl = changedControls[changedControls.length - 1];

    if (lastChangedControl) {
      lastChangedControl.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-sc-product-group-link]');
    if (!link) return;

    storeSelectedOptions(link);
  });

  function init() {
    logWarnings();
    initGloboColorSwatchIntegration();

    if (!document.querySelector('variant-selects')) return;

    if (window.customElements && !customElements.get('variant-selects')) {
      customElements.whenDefined('variant-selects').then(applyStoredOptions);
      return;
    }

    applyStoredOptions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('product:variant-updated', () => {
    logWarnings();
    initGloboColorSwatchIntegration();
  });
})();
